import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5daf769b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relevant" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_ArrowRightOutlined = _resolveComponent("ArrowRightOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.name || '相关内容'), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_row, { gutter: [50,20] }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.showList, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              xs: 24,
              md: 12,
              xl: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["item", `i_${index+1}`])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      alt: "",
                      src: item.image
                    }, null, 8 /* PROPS */, _hoisted_4)
                  ]),
                  _createVNode(_component_a_typography_title, { level: 5 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_a_typography_paragraph, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  (item.button.click)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "button_n_2",
                        onClick: item.button.click
                      }, [
                        _createTextVNode(_toDisplayString(item.button?.name || '查看详情') + " ", 1 /* TEXT */),
                        _createVNode(_component_ArrowRightOutlined)
                      ], 8 /* PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}